import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" id="about" data-id="element-59" data-mp="2prgxr1ek69b5">
      <div className="max-w-4xl mx-auto" data-id="element-60" data-mp="2ptbj2gtqs3fr">
        <div className="text-center mb-12" data-id="element-61" data-mp="2tssnd6xfmujc">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-black uppercase mb-4" data-id="element-62" data-mp="2tv6itgw0y8rf">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-63" data-mp="2ytgfjvxedhf5">
              Ventura County's Trusted Mobile Car Detailing Service
            </span>
          </h2>
          <div className="h-1 w-24 bg-red-600 mx-auto rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-64" data-mp="38nzzh5n18uxo" />
        </div>

        <motion.div initial={{
        y: 30,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-zinc-900/40 rounded-xl border border-zinc-800 p-8 space-y-4" data-id="element-65" data-mp="3hieldr22j3pr">
          <p className="text-gray-300 text-lg leading-relaxed" data-id="element-66" data-mp="2lqz3o92fuqp4">
            Looking for professional{' '}
            <strong className="text-white" data-id="element-67" data-mp="2gse5ef6qyh3b">
              mobile car detailing in Ventura County
            </strong>{' '}
            ? Mike's Pro Detail is a premium, fully mobile auto detailing
            service proudly serving Camarillo, Ventura, Thousand Oaks,
            Simi Valley, and the surrounding Ventura County communities. We
            bring professional-grade car detailing directly to your home,
            office, or anywhere that's convenient for you — no drop-off
            required.
          </p>
          <p className="text-gray-300 text-lg leading-relaxed" data-id="element-68" data-mp="2vod97dmtpv2n">
            Owner-operated by Mike, every vehicle receives personal, hands-on
            attention using only premium, eco-friendly products. From deep
            interior car cleaning and seat shampooing to clay bar treatments,
            hybrid ceramic wax protection, and full car detail services, we
            deliver showroom-quality results at your doorstep. We bring our own
            water and detailing equipment. We require access to a standard
            electrical outlet at the service location.
          </p>
          <p className="text-gray-300 text-lg leading-relaxed" data-id="element-69" data-mp="3thuzu0wlyzew">
            Rated{' '}
            <strong className="text-white" data-id="element-70" data-mp="1elstyku5h9m">5 stars on Google and Yelp</strong>,
            Mike's Pro Detail has earned a loyal customer base across Ventura
            County through honest pricing, reliable scheduling, and results that
            speak for themselves. Whether you need a quick{' '}
            <strong className="text-white" data-id="element-71" data-mp="3akttocrbit9d">wash and wax in Camarillo</strong>, a{' '}
            <strong className="text-white" data-id="element-72" data-mp="3eldsdkrji4xm">
              full car detail in Thousand Oaks
            </strong>
            , or{' '}
            <strong className="text-white" data-id="element-73" data-mp="18u091b2h3lui">
              interior detailing in Simi Valley
            </strong>
            , we treat every vehicle like it's our own.
          </p>
        </motion.div>
      </div>
    </section>;
}